<script>
import TwBadge from '@/components/generic/tw-badge.vue'
import TwUploadedImage from '@/components/generic/uploads/tw-uploaded-image.vue'
import TwListGroup from '@/components/generic/list-group/tw-list-group.vue'
import TwListGroupItem from '@/components/generic/list-group/tw-list-group-item.vue'
import TwGrid from '@/components/generic/tw-grid.vue'
import paginationMixin from '@/mixins/paginationMixin.js'
import fetchDataMixin from '@/mixins/fetchDataMixin.js'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import slideShowMixin from '@/mixins/slideShowMixin.js'
import { useFundraiserUpdatesPublicStore } from '@/stores/fundraiserUpdatesPublic.js'

export default {
  name: 'FundraiserUpdatesViewPublic',
  components: { TwLoadingSpinner, TwGrid, TwListGroupItem, TwListGroup, TwUploadedImage, TwBadge },
  mixins:[paginationMixin, fetchDataMixin, slideShowMixin],
  props: {
    updatableType: {
      type: String,
      required: true
    },
    updatableId: {
      type: Number,
      required: true
    }
  },
  computed: {
    fundraiserUpdates() {
      // @todo this should also be filtered server side
      return useFundraiserUpdatesPublicStore(this.$options.name).getItemsByUpdatable({
        updatable_type: this.updatableType,
        updatable_id: this.updatableId
      })
    },
    slides() {
      return this.$refs.slide.map( item => ({
        id: item.upload.id,
        type: 'upload',
        upload: item.upload,
      }))
    }
  },
  watch: {
    Page() {
      this.fetchFundraiserUpdates()
    }
  },
  onUnmounted() {
    useFundraiserUpdatesPublicStore(this.$options.name).clearItems()
  },
  mounted() {
    this.fetchFundraiserUpdates()
  },
  methods: {
    clearFilters() {
      this.FilterByName = null
      this.fetchFundraiserUpdates()
    },
    async fetchFundraiserUpdates() {
      await this.fetchData(async () => {
        await useFundraiserUpdatesPublicStore(this.$options.name).fetchItems({
          clear: true,
          updatable_type: this.updatableType,
          updatable_id: this.updatableId,
          page: this.Page,
          ...(this.FilterByName ? { name: this.FilterByName  } : {})
        })
      })
    }
  }
}
</script>

<template>
  <tw-loading-spinner v-if="Loading" />
  <tw-list-group v-else-if="fundraiserUpdates && fundraiserUpdates.length > 0">
    <tw-list-group-item v-for="(fundraiserUpdate, updateIndex) in fundraiserUpdates" :key="'fundraiser-update-key-' + fundraiserUpdate.id" class="bg-white p-4 rounded border-gray-400 shadow">
      <div class="flex">
        <div>
          <div>
            Date: <strong>
              {{ $filters.formatDateOnly(fundraiserUpdate.created_at) }}
            </strong>
          </div>
          <p class="mb-4" v-html="fundraiserUpdate.message" />
          <span class="text-sm"> Written by: <tw-badge class="ml-1" variant="blue">{{ fundraiserUpdate.user.name }}</tw-badge> </span>
          <tw-grid v-if="fundraiserUpdate.photos">
            <tw-uploaded-image v-for="(photo, photoIndex) in fundraiserUpdate.photos" ref="slide" :key="'fundraiser-photo-update-key' + photo.id + '-' + photoIndex" :upload="photo" @click.prevent="slideShowItemClicked(slides.findIndex( item => item.id === photo.id))" />
          </tw-grid>
        </div>
      </div>
    </tw-list-group-item>
  </tw-list-group>
  <div v-else class="text-center">
    <p> No updates yet. </p>
  </div>
</template>

<style scoped>

</style>
